var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":_vm.height,"initial-index":_vm.currentIndex,"trigger":"click","autoplay":_vm.autoplay,"interval":_vm.interval,"indicator-position":_vm.indicatorPosition,"arrow":_vm.arrow,"type":_vm.type,"loop":_vm.loop,"direction":_vm.direction}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }